/**
 * Canonical permission string constants.
 * Runtime value === key (e.g. Permission.SELF_BILLING_VIEW === 'SELF_BILLING_VIEW').
 */
const Permission = Object.freeze({
  // ImageKit platform
  ADMIN_PANEL_VIEW: 'ADMIN_PANEL_VIEW',
  ADMIN_PANEL_MANAGE: 'ADMIN_PANEL_MANAGE',
  CLIENT_VIEW: 'CLIENT_VIEW',
  CLIENT_MANAGE: 'CLIENT_MANAGE',
  USER_VIEW: 'USER_VIEW',
  USER_MANAGE: 'USER_MANAGE',
  // Account-scoped
  SELF_ANALYTICS_VIEW: 'SELF_ANALYTICS_VIEW',
  SELF_ANALYTICS_MANAGE: 'SELF_ANALYTICS_MANAGE',
  SELF_BILLING_VIEW: 'SELF_BILLING_VIEW',
  SELF_BILLING_MANAGE: 'SELF_BILLING_MANAGE',
  SELF_CLEAR_CACHE_VIEW: 'SELF_CLEAR_CACHE_VIEW',
  SELF_CLEAR_CACHE_MANAGE: 'SELF_CLEAR_CACHE_MANAGE',
  SELF_CLIENT_VIEW: 'SELF_CLIENT_VIEW',
  SELF_CLIENT_MANAGE: 'SELF_CLIENT_MANAGE',
  SELF_DEVELOPERS_VIEW: 'SELF_DEVELOPERS_VIEW',
  SELF_DEVELOPERS_MANAGE: 'SELF_DEVELOPERS_MANAGE',
  SELF_IMAGE_SETTINGS_VIEW: 'SELF_IMAGE_SETTINGS_VIEW',
  SELF_IMAGE_SETTINGS_MANAGE: 'SELF_IMAGE_SETTINGS_MANAGE',
  SELF_INTEGRATION_VIEW: 'SELF_INTEGRATION_VIEW',
  SELF_INTEGRATION_MANAGE: 'SELF_INTEGRATION_MANAGE',
  RESTRICTED_SELF_MEDIA_LIBRARY_VIEW: 'RESTRICTED_SELF_MEDIA_LIBRARY_VIEW',
  RESTRICTED_SELF_MEDIA_LIBRARY_MANAGE: 'RESTRICTED_SELF_MEDIA_LIBRARY_MANAGE',
  SELF_MEDIA_LIBRARY_VIEW: 'SELF_MEDIA_LIBRARY_VIEW',
  SELF_MEDIA_LIBRARY_MANAGE: 'SELF_MEDIA_LIBRARY_MANAGE',
  SELF_PERFORMANCE_VIEW: 'SELF_PERFORMANCE_VIEW',
  SELF_PERFORMANCE_MANAGE: 'SELF_PERFORMANCE_MANAGE',
  SELF_TEAM_VIEW: 'SELF_TEAM_VIEW',
  SELF_TEAM_MANAGE: 'SELF_TEAM_MANAGE',
  SELF_REFERRAL_VIEW: 'SELF_REFERRAL_VIEW',
  SELF_REFERRAL_MANAGE: 'SELF_REFERRAL_MANAGE',
  SELF_USAGE_VIEW: 'SELF_USAGE_VIEW',
  SELF_USAGE_MANAGE: 'SELF_USAGE_MANAGE',
  SELF_USER_VIEW: 'SELF_USER_VIEW',
  SELF_USER_MANAGE: 'SELF_USER_MANAGE',
  // Agency
  SELF_AGENCY_ANALYTICS_VIEW: 'SELF_AGENCY_ANALYTICS_VIEW',
  SELF_AGENCY_ANALYTICS_MANAGE: 'SELF_AGENCY_ANALYTICS_MANAGE',
  SELF_CHILD_VIEW: 'SELF_CHILD_VIEW',
  SELF_CHILD_MANAGE: 'SELF_CHILD_MANAGE',
});

/**
 * @param {string[] | null | undefined} permissions
 * @param {string} requiredPermission
 * @returns {boolean}
 */
function hasPermission(permissions, requiredPermission) {
  if (!Array.isArray(permissions) || !requiredPermission) {
    return false;
  }
  return permissions.includes(requiredPermission);
}

module.exports = {
  Permission,
  hasPermission,
};
